export { default } from "./AnnotatedText";
